import CreateGroup from "../../superAdmin/group/CreateGroup";
import SuperAdminPolls from "../../superAdmin/polls/List";
import CreateSuperAdminPoll from "../../superAdmin/polls/Create";
import TransactionReport from "../../superAdmin/report/transactions";
import Deactivated from "../../superAdmin/deactivated/Deactivated";
import Data from "../../superAdmin/data/Data";
import DirectoryReview from "../../superAdmin/group/Directory";
import ReferralsReview from "../../superAdmin/group/ReferralsReview";
import TicketsReport from "../../superAdmin/ticketsReport/TicketsReport";
import StatusReport from "../../superAdmin/status/Report";
import Design from "../../superAdmin/logos/logos";
import Registrations from "../../superAdmin/registrations/Registrations";
import Groups from "../../superAdmin/group/Groups";
import { Navigate } from "react-router-dom";
import SuperadminPackages from "../../superAdmin/packages/SuperadminPackages";
import Alerts from "../../superAdmin/alerts/Alerts";
import AlertForm from "../../superAdmin/alerts/AlertForm";
import Adoption from "../../superAdmin/adoption/Adoption";
import Colors from "../../superAdmin/colors/Colors";
import UserRoles from "../../superAdmin/userRoles/UserRoles";

export const superAdminRoutes = [
  { path: "/superadmin/groups/create", element: <CreateGroup /> },
  { path: "/superadmin/groups", element: <Groups /> },
  { path: "/superadmin/registrations", element: <Registrations /> },
  {
    path: "/superadmin/groups/edit/:id",
    element: <CreateGroup />,
  },
  { path: "/superadmin/polls", element: <SuperAdminPolls /> },
  {
    path: "/superadmin/polls/create",
    element: <CreateSuperAdminPoll />,
  },
  {
    path: "/superadmin/polls/edit/:id",
    element: <CreateSuperAdminPoll />,
  },
  {
    path: "/superadmin/report/transactions",
    element: <TransactionReport />,
  },
  { path: "/superadmin/deactivated", element: <Deactivated /> },
  { path: "/superadmin/data", element: <Data /> },
  { path: "/superadmin/directory", element: <DirectoryReview /> },
  { path: "/superadmin/referrals", element: <ReferralsReview /> },
  { path: "/superadmin/adoption", element: <Adoption /> },
  {
    path: "/superadmin/missing-transactions",
    element: <TicketsReport />,
  },

  { path: "/superadmin/design", element: <Design /> },
  {
    path: "/superadmin/logos",
    element: <Navigate to="/superadmin/design" replace />,
  },
  { path: "/superadmin/packages", element: <SuperadminPackages /> },
  {
    path: "/superadmin/alerts",
    element: <Alerts />,
  },
  {
    path: "/superadmin/alerts/create",
    element: <AlertForm />,
  },
  {
    path: "/superadmin/alerts/edit/:alertId",
    element: <AlertForm />,
  },
  { path: "/superadmin/status/report", element: <StatusReport /> },
  { path: "/superadmin/colors", element: <Colors /> },
  { path: "/superadmin/user-roles", element: <UserRoles /> },

  {
    path: "/login",
    element: <Navigate to="/superadmin/groups" replace />,
  },
  {
    path: "/",
    element: <Navigate to="/superadmin/groups" replace />,
  },
];
